module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-10 box-link",
    class: _vm.number
  }, [(_vm.to) ? _c('router-link', {
    staticClass: "link-content",
    attrs: {
      "to": _vm.to
    }
  }, [_c('div', [_c('div', {
    staticClass: "link-icon"
  }, [_c('i', {
    class: _vm.iconClass
  })]), _vm._v(" "), _c('div', {
    staticClass: "link-text"
  }, [_vm._v(_vm._s(_vm.title))])])]) : _vm._e(), _vm._v(" "), (_vm.href) ? _c('a', {
    staticClass: "link-content",
    attrs: {
      "href": _vm.href,
      "target": {
        '_blank': _vm.href
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "link-icon"
  }, [_c('i', {
    class: _vm.iconClass
  })]), _vm._v(" "), _c('div', {
    staticClass: "link-text"
  }, [_vm._v(_vm._s(_vm.title))])])]) : _vm._e(), _vm._v(" "), (!_vm.href && !_vm.to) ? _c('div', {
    staticClass: "link-content",
    on: {
      "click": function($event) {
        return _vm.click()
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "link-icon"
  }, [_c('i', {
    class: _vm.iconClass
  })]), _vm._v(" "), _c('div', {
    staticClass: "link-text"
  }, [_vm._v(_vm._s(_vm.title))])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-58a24752!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/dashboard/BoxLink.vue
// module id = 546
// module chunks = 2